module.exports = __webpack_public_path__ + "static/illustration-lg-a34a5bfc76506f744864bbcc29ec7a36.png";